import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bacgwqg9jp: FaireBrandEntity = {
  token: "b_bacgwqg9jp",
  type: "brand",
  name: "Blaze Herbals",
  avatarUrl:
    "https://cdn.faire.com/fastly/c1a213d7df9e6b8e318703d24bf2c8c10219be05ba8c0c215d7c581112099778.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/6ac96c1681bba26b3581ade3389a8c3a94ed8e4ff2a1f9a45dbced3d2bd33546.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/c1a213d7df9e6b8e318703d24bf2c8c10219be05ba8c0c215d7c581112099778.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/6ac96c1681bba26b3581ade3389a8c3a94ed8e4ff2a1f9a45dbced3d2bd33546.jpeg",
  location: "San Antonio , TX, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "Hi, I'm Blaise, Founder of Blaze Herbals.\n\nGrowing up on a farm in upstate New York sparked my deep connection to plants and natural living. After over a decade in healthcare administration, I faced chronic health issues including undiagnosed Lyme Disease and digestive struggles that conventional medicine couldn’t solve.\n\nMy healing journey led me to Ayurveda and herbal medicine, where I finally found answers. Through natural remedies and lifestyle changes, I reclaimed my health and discovered a passion for helping others do the same.\n\nAt Blaze Herbals, I create small-batch, plant-based remedies rooted in ancient wisdom to support your wellness because you shouldn’t have to walk your healing path alone.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:45:24.226Z",
    importedBy: "entity-db-cli",
  },
};
